import React, { useState } from "react";
import { FaChevronDown, FaQuestionCircle } from "react-icons/fa";

const itemsFromSite = (contact) => [
  {
    q: "What is Sari-Sari Software Development?",
    a: "Sari-Sari Software Development OPC is a proudly Pinoy software company that builds practical, reliable, and user-friendly digital solutions inspired by the trust and accessibility of the neighborhood sari-sari store.",
  },
  {
    q: "What services and products do you offer?",
    a: "We offer Web Development, CRM systems, Event Management tools, and custom software solutions designed to help businesses grow and operate more efficiently.",
  },
  {
    q: "Do you build custom software solutions?",
    a: "Yes. We design and develop tailor-made systems based on your business needs, workflows, and goals—whether it’s a website, internal system, or customer platform.",
  },
  {
    q: "Who can use Sari-Sari’s products?",
    a: "Our products are built for startups, small to medium businesses, and growing teams that want modern, easy-to-use software without unnecessary complexity.",
  },
  {
    q: "Is support available?",
    a: "Yes. We provide reliable support and assistance to ensure our clients can use our products smoothly and confidently.",
  },
];


export const Faq = ({ contact }) => {
  const [openIndex, setOpenIndex] = useState(null);
  const items = itemsFromSite(contact);

  const toggle = (i) => setOpenIndex((prev) => (prev === i ? null : i));

  return (
    <section id="faq" className="faq-section">
      <div className="container">
        <div className="faq-header">
          <div className="faq-label">FAQ</div>
          <h2 className="faq-title">Frequently Asked Questions</h2>
          <p className="faq-subtitle">Everything you need to know about Sari‑Sari</p>
        </div>

        <div className="faq-list">
          {items.map((item, i) => (
            <div
              key={i}
              className={`faq-card ${openIndex === i ? "open" : ""}`}
              onClick={() => toggle(i)}
            >
              <div className="faq-question">
                <div className="faq-question-left">
                  <span className="faq-icon"><FaQuestionCircle /></span>
                  <span className="faq-text">{item.q}</span>
                </div>
                <FaChevronDown
                  className={`faq-chevron ${openIndex === i ? "open" : ""}`}
                />
              </div>
              <div className={`faq-content ${openIndex === i ? "open" : ""}`}>
                <div className="faq-answer">
                  <p>{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
